<template>
  <div class="calico-financial-documents-page">
    <div class="calico-financial-documents-container">
      <CalicoFinancialDocuments>
        <template #content>
          <p class="body--small">
            [ slot content goes here ]
          </p>
        </template>
      </CalicoFinancialDocuments>
    </div>
  </div>
</template>

<script>
import CalicoFinancialDocuments from '@/components/pattern/financialDocuments/index.vue'

export default {
  name: 'CalicoFinancialDocumentsPage',
  components: {
    CalicoFinancialDocuments,
  },
}
</script>

<style scoped lang="scss">
.calico-financial-documents-page {
  @include inline-space($space-none);
  justify-content: center;
  align-items: center;

  .calico-financial-documents-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 630px;
  }
}
</style>